export const PlusOutlineIcon = ({ className }: { className?: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M25.196 13.06H.926M12.939 25.075V.805" />
    </g>
  </svg>
)
